import {
  VIDEO_ACCEPT,
  VIDEO_CANCEL,
  VIDEO_DECLINED,
  VIDEO_INITIATE,
  VIDEO_JOIN,
  VIDEO_MISS,
  VIDEO_START,
  VIDEO_STOP,
  VIDEO_STOPPED
} from "../constants/actionTypes";
import {USER_LOGGED_OUT} from "../../user/constants/actionTypes";
import {
  RC_CLOSE,
  RC_MESSAGE_UNREAD,
  RC_OPEN
} from "../../../shared/modules/rocketChat/constants/actionTypes";
import {TW_VIDEO_TAG} from "../../../shared/modules/twilio/constants";

const defaultState = {
  isInitiated: false,
  isEstablished: false,
  isJoined: false,
  isOnline: false,
  room: "",
  user: "",
  missed: {}
};

export const videoReducer = (state = defaultState, action) => {
  switch (action.type) {
    case USER_LOGGED_OUT:
      return defaultState;
    case VIDEO_INITIATE:
      return {
        ...state,
        isInitiated: true
      };
    case VIDEO_START:
      return {
        ...state,
        missed: {
          ...state.missed,
          [action.user]: 0
        },
        isEstablished: true,
        room: action.room,
        user: action.user
      };
    case VIDEO_ACCEPT:
      return {
        ...state,
        room: action.room,
        user: action.user,
        isEstablished: true
      };
    case VIDEO_JOIN:
      return {
        ...state,
        isJoined: true
      };
    case VIDEO_CANCEL:
    case VIDEO_DECLINED:
    case VIDEO_STOP:
    case VIDEO_STOPPED:
      return {
        ...state,
        room: "",
        user: "",
        isInitiated: false,
        isJoined: false,
        isEstablished: false
      };
    case VIDEO_MISS:
      return {
        ...state,
        missed: {
          ...state.missed,
          [action.user]: (state.missed[action.user] || 0) + 1
        }
      };
    case RC_MESSAGE_UNREAD:
      return {
        ...state,
        missed: {
          ...state.missed,
          [action.room.name]: action.messages.reduce((missed, message) => {
            return message.msg.startsWith(TW_VIDEO_TAG)
              ? missed + 1
              : missed;
          }, 0)
        }
      };
    case RC_OPEN:
      return {
        ...state,
        isOnline: true
      };
    case RC_CLOSE:
      return {
        ...state,
        isOnline: false
      };
    default:
      return state;
  }
};
